import AwsApolloProvider from './AwsApolloProvider';

export default AwsApolloProvider;
